import React from 'react';
import {useIntl} from 'react-intl';
import PropTypes from 'prop-types';
import AppTableContainer from '@crema/core/AppTableContainer';

export const MedicationTable = (props) => {
  const intl = useIntl();

  const {request} = props;

  const columns = [
    {
      title: intl.messages['medication.name'],
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: intl.messages['medication.startTime'],
      dataIndex: 'period',
      key: 'period',
      render: (period) => <span>{period.start}</span>,
    },
    {
      title: intl.messages['medication.endTime'],
      dataIndex: 'period',
      key: 'period',
      render: (period) => <span>{period.end}</span>,
    },
    {
      title: intl.messages['medication.quantity'],
      dataIndex: ['quantity', 'value'],
      key: 'value',
    },
    {
      title: intl.messages['medication.unit'],
      dataIndex: ['quantity', 'unit'],
      key: 'unit',
      render: (unit) => (
        <span>{intl.messages[`medication.unit.${unit.toLowerCase()}`]}</span>
      ),
    },
  ];

  return (
    <>
      <AppTableContainer
        className='customer-table'
        hoverColor
        data={request?.medications}
        columns={columns}
        scroll={{x: 'auto'}}
        expandable={{
          expandedRowRender: (record) => (
            <p
              style={{
                margin: 0,
              }}>
              {record.instruction}
            </p>
          ),
        }}
      />
    </>
  );
};

MedicationTable.propTypes = {
  request: PropTypes.object,
};
